import { useState, useEffect, useCallback } from 'react';
import customAxios from '../../util/Api';
import authHeader from 'services/auth/jwt/auth-header';

export const REQUISITION_OPTIONS = ['Purchase', 'Diesel Purchase', 'Return', 'Accommodation', 'Recharge'];

export function useMappingDepartments() {
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchDepartments = useCallback(async (filters = {}) => {
    setLoading(true);
    setError(null);
    try {
      const params = new URLSearchParams();
      if (filters.deptNumber) params.append('DeptNumberDoNotEdit', filters.deptNumber);
      if (filters.requisitionType) params.append('RequisitionType', filters.requisitionType);

      const { data } = await customAxios.get(`/Ops/GetMappingDepartments?${params.toString()}`, { headers: authHeader() });
      setDepartments(Array.isArray(data) ? data : []);
    } catch (err) {
      setError(err?.response?.data?.error || err.message || 'Failed to load departments');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchDepartments();
  }, [fetchDepartments]);

  const addDepartment = async payload => {
    const { data } = await customAxios.post('/Ops/AddMappingDepartments', payload, { headers: authHeader() });
    await fetchDepartments();
    return data;
  };

  const editDepartment = async payload => {
    await customAxios.post('/Ops/EditMappingDepartments', payload, { headers: authHeader() });
    await fetchDepartments();
  };

  const deleteDepartment = async deptNumber => {
    await customAxios.post(`/Ops/DeleteMappingDepartments?DeptNumberDoNotEdit=${deptNumber}`, { headers: authHeader() });
    await fetchDepartments();
  };

  return {
    departments,
    loading,
    error,
    fetchDepartments,
    addDepartment,
    editDepartment,
    deleteDepartment,
  };
}
